var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNfc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.6509 4.64062L35.2979 7.6333C39.9171 12.8083 42.751 19.6048 42.751 27.0703C42.751 34.5358 39.9171 41.339 35.2979 46.5117L38.6509 49.5C43.9811 43.5308 47.251 35.6856 47.251 27.0703C47.251 18.4551 43.9811 10.6121 38.6509 4.64062ZM31.9404 10.626L28.5874 13.6143C31.7869 17.1963 33.751 21.9021 33.751 27.0703C33.751 32.2386 31.7869 36.9488 28.5874 40.5308L31.9404 43.519C35.8509 39.1428 38.251 33.3883 38.251 27.0703C38.251 20.7523 35.8509 15.0022 31.9404 10.626ZM25.2388 16.6069L21.8638 19.6172C23.639 21.6084 24.751 24.1993 24.751 27.0703C24.751 28.2874 24.5149 29.4405 24.1489 30.5332L13.2593 20.8037C13.2622 20.7994 13.2651 20.7949 13.2681 20.7905L9.84912 17.7539C7.95012 20.3504 6.8125 23.5417 6.8125 27C6.8125 30.4583 7.95012 33.6473 9.84912 36.2461L13.2681 33.2095C12.0598 31.4275 11.3125 29.3107 11.3125 27C11.3125 26.4033 11.3674 25.8192 11.4619 25.251L21.8594 34.5278L25.2344 37.5381C27.7229 34.7526 29.251 31.0911 29.251 27.0703C29.251 23.0496 27.725 19.3924 25.2388 16.6069Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNfc);
export default __webpack_public_path__ + "static/media/nfc.74b355995a2af00e5a8a5cf3cb3ef524.svg";
export { ForwardRef as ReactComponent };